import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Settings, X, Book, Workflow } from 'lucide-react';
export function SimplifiedSidebar({
  isOpen,
  onClose
}) {
  const navigation = [{
    name: 'Dashboard',
    href: '/',
    icon: LayoutDashboard
  }, {
    name: 'Patients',
    href: '/patients',
    icon: Users
  }, {
    name: 'Knowledge Base',
    href: '/knowledge-base',
    icon: Book
  }, {
    name: 'Integration Agent',
    href: '/data-agent',
    icon: Workflow
  }, {
    name: 'Settings',
    href: '/settings',
    icon: Settings
  }];
  return <>
      {/* Mobile overlay */}
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onClose} data-id="element-435" />}

      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 transform transition-transform duration-200 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`} data-id="element-436">
        <div className="flex flex-col h-full" data-id="element-437">
          {/* Logo */}
          <div className="flex items-center justify-between h-20 px-6 border-b border-gray-200" data-id="element-438">
            <div className="flex items-center gap-2" data-id="element-439">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eueX628T3WjjqNytigg9YH/Asika_Icon.svg" alt="Asika Logo" className="h-8 w-auto" data-id="element-440" />
            </div>
            <button className="lg:hidden p-2 rounded-md hover:bg-gray-100" onClick={onClose} data-id="element-441">
              <X size={20} data-id="element-442" />
            </button>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-8 space-y-2 overflow-y-auto" data-id="element-443">
            {navigation.map(item => <NavLink key={item.name} to={item.href} onClick={onClose} className={({
            isActive
          }) => `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all ${isActive ? 'bg-black text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-444">
                <item.icon size={18} data-id="element-445" />
                {item.name}
              </NavLink>)}
          </nav>

          {/* Footer */}
          <div className="p-6 border-t border-gray-200" data-id="element-446">
            <div className="text-xs text-gray-500 text-center" data-id="element-447">
              Patient Registration MVP v1.0
            </div>
          </div>
        </div>
      </aside>
    </>;
}